import {autoinject, bindable} from 'aurelia-framework';
import {Dispatch} from "../services/dispatch";

@autoinject()
export class ToggleOnClickCustomAttribute {
    @bindable({primaryProperty: true}) tag: string;
    @bindable childrenOnly: boolean = false;
    closeMenu: any;

    constructor(private element: Element,
                private dispatch: Dispatch) {
        this.closeMenu = e => {

            const selector = `[reveal="${this.tag}"]`;
            const reveal_elements = document.querySelectorAll(selector);

            if (this.element.contains(e.target)
                || ( Array.from(reveal_elements).find((el)=> el.contains(e.target))
                    && !this.childrenOnly)
            ) return;

            if (this.childrenOnly) {
                this.dispatch.setState(this.tag, null, this);
            } else {
                this.dispatch.setState(this.tag, null);
            }

            document.removeEventListener('click', this.closeMenu, {capture: false});
            return true;
        };

        this.element.addEventListener('click', (event) => {
            this.onClick(event);
        }, {capture: false});

    }


    onClick(event) {

        if (this.childrenOnly) {
            this.dispatch.setState(this.tag, 'toggle', this);
        } else {
            this.dispatch.setState(this.tag, 'toggle');
        }
        document.removeEventListener('click', this.closeMenu, {capture: false});
        return true;
    }


}
